"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.calcVidSettings = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var calcVidSettings = function calcVidSettings(_ref, breakpoints, windowWidth) {
  var zoom = _ref.zoom;
  var variant = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'standard';
  // the following aspectRatio hack is required in order to allow overlay to be positioned correctly on hero
  var vidSettings = {
    aspectRatio: '1:0',
    zoom: '1',
    height: '100%'
  }; //  zoom mapping magic numbers

  var zoomMapping = {
    large: ['2.26', '1.49', '1.11', '1.11', '1.11', '1.25'],
    standard: ['2.13', '1.39', '1.04', '1.25', '1.27', '1.76'],
    article: ['2.13', '1.39', '1.04', '1.25', '1.27', '1.76']
  };
  var activeBreakpoint = [windowWidth, 357].concat((0, _toConsumableArray2.default)(breakpoints)) // add extra breakpoint to improve small device visibility and currentWidth
  .sort(function (a, b) {
    return parseInt(a, 10) - parseInt(b, 10);
  }) // sort the numbers from least to greatest
  .indexOf(windowWidth); // get the index of windowWidth

  vidSettings.zoom = zoom || zoomMapping[variant][activeBreakpoint];
  return vidSettings;
};

exports.calcVidSettings = calcVidSettings;
var _default = calcVidSettings;
exports.default = _default;